const CONST = {
    RESET: 'FAVICON_GENERATOR/RESET',
    UPDATE_STATE: 'FAVICON_GENERATOR/UPDATE_STATE',
    UPDATE_FILES: 'FAVICON_GENERATOR/UPDATE_FILES',
};

export default CONST;
